module.exports = __webpack_public_path__ + "img/onboarding-icon-questions.0478898d.svg";